import { AddCircle, Clear, Create, Done, Search } from "@mui/icons-material"
import { Button } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import { useState, useContext, useEffect } from "react"
import OneButton from "../../../Components/OneButton/OneButton"
import OneInput from "../../../Components/OneInput/OneInput"
import OneTable from "../../../Components/OneTable/OneTable"
import { WebSocketContext } from "../../../Providers/WebSocket/WebSocketContext"
import { filtroTextoPesquisa } from "../../../Utils/Utils"
import { CadastroEquipe } from "./CadastroEquipe/CadastroEquipe"

const EquipesConfig = () => {
    const [openCadastro, setOpenCadastro] = useState(false)
    const [idToEdit, setIdToEdit] = useState(null)

    const tableColumns = [
        {
            name: 'Código',
            selector: row => row.id,
            grow: 0.4
        },
        {
            name: 'Descrição',
            selector: row => row.descricao,
            grow: 3
        },
        {
            name: 'Ativo',
            selector: row => row.ativo ? <Done sx={{ color: "green" }} /> : <Clear sx={{ color: "red" }}/>
        },
        {
            name: 'Editar',
            cell: (row) => <Create sx={{ cursor: 'pointer' }} onClick={() => { editEquipe(row.id) }}/>,
            button: true
        }
    ]

    const { sendWs, addRoute } = useContext(WebSocketContext)

    const [filterText, setFilterText] = useState('')
    const [textToSearch, setTextToSearch] = useState('')
    const [loading, setLoading] = useState(false)
    const [equipeList, setEquipeList] = useState(false)
    const filteredDataList = filtroTextoPesquisa(equipeList, filterText, ['descricao'])

    const handleSearch = (event) => {
        event.preventDefault()
        setFilterText(textToSearch)
    }

    const handleChange = (event) => {
        setTextToSearch(event.target.value)
    }

    const getWsResponse = (msg) => {
        setEquipeList(msg.data.equipes)
        setLoading(true)
    }

    useEffect(() => {
        addRoute("buscarTodasEquipes", getWsResponse)
        sendWs("buscarTodasEquipes")
    }, [])

    const editEquipe = (id) => {
        setIdToEdit(id)
        setOpenCadastro(true)
    }

    return (
        <Grid xs={12} sx={{ width: '100%', height: '100%', display: 'flex', flexFlow: 'column' }} flexDirection="column" rowGap={1}>
            {openCadastro &&
            <CadastroEquipe
                openCadastro={openCadastro}
                setOpenCadastro={setOpenCadastro}
                idToEdit={idToEdit}
                setIdToEdit={setIdToEdit}
            />
            }
            <Grid container xs={12} sx={{ alignItems: 'center', height: '50px' }}>
                <Grid xs={12} sm={6}>
                    <form
                        onSubmit={handleSearch}
                    >
                        <Grid container columnGap={1} xs={12} sx={{ alignItems: 'center' }}>
                            <Grid xs={6} sm={7.5}>
                                <OneInput name="pesquisar" onChange={handleChange} />
                            </Grid>
                            <Grid xs={4} sm={4}>
                                <OneButton
                                    id="button_teste"
                                    color="one_primary"
                                    variant="contained"
                                    type="submit"
                                    IconStart={Search}
                                >
                                     Pesquisar
                                </OneButton>
                            </Grid>
                        </Grid>
                    </form>
                </Grid>
                <Grid xs={6} sx={{ alignItems: 'center' }}>
                    <Grid container justifyContent="flex-end">
                        <Button
                            id="button_teste"
                            color="one_primary"
                            variant="contained"
                            onClick={() => { setIdToEdit(null); setOpenCadastro(true) }}
                            sx={{ width: '148px', height: '30px' }}
                        >
                            <AddCircle sx={{ marginRight: '7px' }} />
                            Novo
                        </Button>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container xs={12} sx={{
                // padding: '5px',
                backgroundColor: '#D9D9D9',
                borderRadius: '5px',
                display: 'flex',
                flexGrow: 1,
                flexBasis: 'auto'
                // overflowY: 'scroll',
                // "::-webkit-scrollbar": {
                //     width: "6px",
                //     borderRadius: '5px'
                // },
                // "::-webkit-scrollbar-track": {
                //     background: "#D9D9D9",
                //     borderRadius: '5px'
                // },
                // "::-webkit-scrollbar-thumb": {
                //     background: "#888",
                //     borderRadius: '5px'
                // },
                // "::-webkit-scrollbar-thumb:hover": {
                //     background: "#555",
                //     borderRadius: '5px'
                // }
            }}>
                {equipeList &&
                <OneTable
                    columns={tableColumns}
                    data={filteredDataList}
                    progressPending={!loading}
                    dobleClickCallback={editEquipe}
                    // pagination
                    // paginationPerPage={rowsPage}
                    // paginationRowsPerPageOptions={[rowsPage, 5, 10, 15, 20, 25, 30]}
                    // paginationComponentOptions={ { rangeSeparatorText: "de", rowsPerPageText: 'Itens por página' } }
                />
                }
            </Grid>
        </Grid>
    )
}

export default EquipesConfig
